<template>
    <div class="copyRight">
        <p>Copyright © www.onecode.cc, All Rights Reserved.</p>
        <p>广州源码区块链科技有限公司 | 技术支持</p>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    components: {
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style lang='scss' scoped>
.copyRight {
    width: 100%;
    p {
        width: 100%;
        text-align: center;
        line-height: 20px;
        color: #999;
        font-size: 12px;
    }
}
</style>